import { Link } from "react-router-dom";
import { CircleDotIcon } from "lucide-react";

import { useNvrClips, useRecordingConfigs } from "@/api/recordings";
import { Card, CardContent } from "@/components/ui/card";


export function DashboardRecordingWidget() {
  const configs = useRecordingConfigs();
  const clips = useNvrClips();

  const recordingCount =
    configs.data?.items?.filter((c) => c.enabled).length ?? 0;
  const totalCount = configs.data?.items?.length ?? 0;
  const retrievedClips =
    clips.data?.items?.filter((c) => c.status === "ready").length ?? 0;

  return (
    <Card>
      <CardContent className="flex items-center justify-between p-4">
        <div>
          <p className="flex items-center gap-2 text-xs uppercase tracking-wider text-muted-foreground">
            <CircleDotIcon className="h-3 w-3 text-[#ff6d00]" />
            Recording
          </p>
          <p className="mt-1 text-3xl font-semibold">
            {recordingCount}
            <span className="text-base text-muted-foreground">
              /{totalCount}
            </span>
          </p>
          <p className="text-xs text-muted-foreground">
            cameras recording · {retrievedClips} clips retrieved
          </p>
        </div>
        <Link
          to="/recordings"
          className="text-xs text-[#ff6d00] hover:underline"
        >
          View →
        </Link>
      </CardContent>
    </Card>
  );
}
